export enum Menus {
  EDIT = 'Modifier un lot de cartes',
  CREATE = 'Créer un lot de cartes',
  MAPS = 'Gestion des maps',
  SECTORS = 'Gestion des secteurs / métiers',
  STEPS = 'Gestion des étapes',
  MANAGE = 'Gestion des publications',
  STATS = 'Statistiques'
}
